(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("Survey", ["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["Survey"] = factory(require("react"), require("react-dom"));
	else
		root["Survey"] = factory(root["React"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_175__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition